//QuizCategories.js
import { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  CardActionArea,
  Button,
  IconButton,
  Menu,
  MenuItem,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import NodeAPI from "../api"; // Adjust this path if needed
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useAuth } from "../context/AuthContext";
import QuizGeneratorMeta from "../components/QuizGeneratorMeta";

const QuizCategories = () => {
  const [categories, setCategories] = useState([]);
  const { user } = useAuth();
  const navigate = useNavigate();

  // Menu state
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = (path) => {
    setAnchorEl(null);
    if (path) {
      navigate(path);
    }
  };

 const handleLogout = () => {
    localStorage.removeItem("token");
    setAnchorEl(null);
    navigate("/");
  };

  const exitCategory = () => {
    localStorage.removeItem("token");
    window.location.href = "/";
  };

  useEffect(() => {
    NodeAPI.get("/quiz/categories").then(({ data }) => setCategories(data));
  }, []);

  return (
    <Box sx={{ textAlign: "center", mt: 4 }}>
      {/* Header with profile menu */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
          px: 2,
        }}
      >
        <Typography variant="h4" sx={{ fontWeight: "bold" }}>
          Quiz Categories
        </Typography>

        {/* Profile Icon with Menu */}
        <div>
          <IconButton
            color="primary"
            onClick={handleMenuClick}
            aria-controls="profile-menu"
            aria-haspopup="true"
            size="large"
          >
            <AccountCircleIcon />
          </IconButton>
          <Menu
            id="profile-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={() => handleMenuClose()}
          >
            <MenuItem onClick={() => handleMenuClose("/profile")}>Profile</MenuItem>
            <MenuItem onClick={() => handleMenuClose("/notifications")}>Quiz Notifications</MenuItem>
            <MenuItem onClick={() => handleMenuClose("/uploadquiz")}>Upload Quiz</MenuItem>
            <MenuItem onClick={() => handleMenuClose("/generate_quiz")}>Generate Quiz</MenuItem>
            <MenuItem onClick={() => handleMenuClose("/categories")}>Categories</MenuItem>
            {user?.role === "admin" && <MenuItem onClick={() => handleMenuClose("/admin")}>Admin</MenuItem>}
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
          </Menu>
        </div>
      </Box>

      {/* Categories Grid */}
      <Grid container spacing={3} justifyContent="center">
        {categories.map((cat) => (
          <Grid item key={cat.id} xs={12} sm={6} md={4} lg={3}>
            <Card
              sx={{
                minWidth: 200,
                bgcolor: "#f5f5f5",
                "&:hover": { boxShadow: 4 },
              }}
            >
              <CardActionArea component={Link} to={`/topics/${cat.id}`}>
                <CardContent>
                  <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                    {cat.name}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Buttons */}
      <Box sx={{ mt: 4, display: "flex", justifyContent: "center", gap: 2 }}>
        <Button
          variant="outlined"
          color="secondary"
          onClick={exitCategory}
          sx={{ fontWeight: "bold" }}
        >
          Exit
        </Button>

        <Button
          variant="contained"
          color="primary"
          component={Link}
          to="/generate_quiz"
          sx={{ fontWeight: "bold" }}
        >
          Generate Quiz
        </Button>
      </Box>
    </Box>
  );
};

export default QuizCategories;
